import React from "react";
// react component for creating beautiful carousel
import Carousel from "react-slick";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import LocationOn from "@material-ui/icons/LocationOn";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";


import carouselStyle from "assets/jss/material-kit-react/views/componentsSections/carouselStyle.jsx";



import civil4 from "assets/img/civil4.jpg";
import civil5 from "assets/img/civil5.jpg";
import civil6 from "assets/img/civil6.jpg";
import civil7 from "assets/img/civil7.jpg";
import civil from "assets/img/cservice.jpg";

class SectionCarousel extends React.Component {
  render() {
    const { classes } = this.props;
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,

    };
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={8} className={classes.marginAuto}>
              <Card carousel>
                <Carousel {...settings}>
                   <div>
                    <img
                      src={civil}
                      alt="CIVIL"
                      className="slick-image"
                    />
                  <div>
                   <h4 className={classes.text}>
                      <LocationOn/>4-In-1 Rail and Bus Depot
(Singapore)
                      </h4>
                    </div>
                  </div>

              <div>
                    <img
                      src={civil4}
                      alt="CIVIL"
                      className="slick-image"
                    />
                  <div>
                   <h4 className={classes.text}>
                      <LocationOn/>MRT Downtown Line
 Jalan Besar Station (Singapore)
                      </h4>
                    </div>
                  </div>
                   <div>
                    <img
                      src={civil5}
                      alt="CIVIL"
                      className="slick-image"
                    />
                  <div>
                   <h4 className={classes.text}>
                      <LocationOn/>Static Pile Load Test 
(Kentledge Method)
                      </h4>
                    </div>
                  </div>
                   <div>
                    <img
                      src={civil6}
                      alt="CIVIL"
                      className="slick-image"
                    />
                 <div>
                   <h4 className={classes.text}>
                      <LocationOn/>Marina Coastal Express Way (MCE)
(Singapore)
                      </h4>
                    </div>
                  </div>

                      <div>
                    <img
                      src={civil7}
                      alt="CIVIL"
                      className="slick-image"
                    />
                   <div>
                   <h4 className={classes.text}>
                      <LocationOn/>Marina Coastal Express Way (MCE)
(Singapore)
                      </h4>
                    </div>
                  </div>
                  
                </Carousel>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(carouselStyle)(SectionCarousel);



// WEBPACK FOOTER //
// ./src/views/CivilPage/Sections/SectionCarousel.jsx